import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { isManagementRole } from '@/types';

interface ManagementRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for admin and supervisor roles.
 * Use for operational management features like Teams.
 */
export function ManagementRoute({ children }: ManagementRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user || !isManagementRole(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
